import { WEIGHT_RANGE_CONFIG } from "@constants/weight-range-config";
import { ToggleFormGroup } from "@containers/common/toggle-form-group/toggle-form-group";
import { LabelWidthTypes } from "@enums/label-width-types";
import { FormattedRpServiceConfigurationServiceOffering } from "@idw-types/data/rp-service-configuration";
import Slider from "@mui/material/Slider";
import { ChangeEvent, useState, useMemo } from "react";
import styles from './service-offering-weights-control.less';


type ServiceOfferingWeightsControlProps = {
    isDisabled: boolean;
    serviceOffering: FormattedRpServiceConfigurationServiceOffering;
    id?: string;
    setServiceOfferingState: (so: FormattedRpServiceConfigurationServiceOffering) => void;
}

function valuetext(value: number) {
    return `${value}`;
}

export const ServiceOfferingWeightsControl = (props: ServiceOfferingWeightsControlProps) => {
    const { isDisabled, serviceOffering, setServiceOfferingState } = props;
    const [labelWidth] = useState(LabelWidthTypes.EXTRA_SMALL);

    const onToggleChange = (event: ChangeEvent<HTMLInputElement>) => {
        const weight = event ? '1' : '0';
        setServiceOfferingWeight(weight);
    }

    const marks = useMemo(() => {
        const marks = [];
        for (let i = 0; i <= 10; i++) {
            marks.push({
                value: i,
                label: `${i}`
            })
        }

        return marks;
    }, [])

    const onSlideChange = (event: React.ChangeEvent<any>, value: number | number[]) => {
        if (value !== null) {
            setServiceOfferingWeight(`${value}`);
        }
    }

    const setServiceOfferingWeight = (value = '0') => {
        setServiceOfferingState({
            ...serviceOffering,
            weight: value
        })
    }


    return <div className={styles.serviceOfferingWeightControl}>
        <span className={styles.serviceOfferingWeightControlItem}>{serviceOffering.name}</span>
        <Slider
            aria-label="Attribute Provider weight"
            defaultValue={Number(serviceOffering.weight)}
            getAriaValueText={valuetext}
            valueLabelDisplay="auto"
            step={WEIGHT_RANGE_CONFIG.step}
            marks={marks}
            min={WEIGHT_RANGE_CONFIG.range.min}
            max={WEIGHT_RANGE_CONFIG.range.max}
            onChangeCommitted={onSlideChange}
            disabled={isDisabled}
        />

        <span className={styles.serviceOfferingWeightControlItem}>
            <ToggleFormGroup
                className={styles.serviceOfferingWeightToggle}
                label={''}
                controlId={`service-offering-weight-toggle-${props?.id || ''}`}
                automationId={""}
                ariaLabel={""}
                checkedIcon={false}
                uncheckedIcon={false}
                labelWidth={labelWidth}
                checked={serviceOffering.weight !== '0'}
                disabled={isDisabled}
                isRequired={false}
                onChange={onToggleChange}
                value={`${serviceOffering.weight !== '0'}`}
            />
        </span>

    </div>
}